export const colorVariables = {
  blue_smalt: '#2288FF',
  blue_navyblue: '#0055FF',
  blue_ribbon: '#006EFF',
  blue_doger: '#2A8DFF',
  gray: '#A6A6A6',
  gray_cod: '#1A1A1A',
  gray_nightrider: '#333333',
  gray_darkgray: '#808080',
  gray_lightgray: '#CCCCCC',
  gray_smokegray: 'rgba(255, 255, 255, .5)',
  gray_lightsmoke: 'rgba(255, 255, 255, .35)',
  gray_verylightgray: '#D1D1D1',
  gray_zircon: '#E6E7E8',
  black: 'black',
  white: 'white',
  white_gainsboro: '#D8D8D8',
  white_lightgainsboro: '#D9D9D9',
  white_verylightgainsboro: '#DEDEDE',
  white_smoke: '#F2F2F2',
  green_light: '#22BB55',
  red: '#FF3333',
  red_bright: '#FF1111',
  yellow_dark: '#FF9900',
  turquoise: '#00C3C3',
  orange: '#FF6600',
  error: 'linear-gradient(0deg, #FF3333 0%, #FF1111 100%)',
  success: 'linear-gradient(0deg, #33CC66 0%, #22BB55 100%)',
};

export const fontVariables = {
  fs_xxxs: '10px',
  fs_xxs: '12px',
  fs_xs: '13px',
  fs_s: '14px',
  fs_md: '16px',
  fs_l: '18px',
  fs_xl: '20px',
  fs_xxl: '24px',
  fs_xxxl: '28px',
};

export const fontFamilyVariables = {
  din_regular: "'PF DinDisplay Pro Regular', sans-serif",
  din_medium: "'PF DinDisplay Pro Medium', sans-serif",
  din_bold: "'PF DinDisplay Pro Bold', sans-serif",
};

export const buttonSizeVariables = {
  s: '105px',
  m: '160px',
  l: '180px',
  xl: '240px',
};

export const socialsColor = {
  gplus: '#E2492A',
  fb: '#3A5998',
  twitter: '#55ACEE',
};

export const socialsHoverColor = {
  gplus: '#F86050',
  fb: '#486DB6',
  twitter: '#69C8FF',
};

export const socialsActiveColor = {
  gplus: '#D1362D',
  fb: '#293D79',
  twitter: '#3A93E9',
};

export const mediaTemplates = {
  xxs: '@media screen and (max-width: 469px)',
  xs: '@media screen and (max-width: 539px)',
  m: '@media screen and (min-width: 730px) and (min-height: 400px)',
  l: '@media screen and (min-width: 820px) and (min-height: 520px)',
  xl: '@media screen and (min-width: 1200px)',
  xxl: '@media screen and (min-width: 1440px)',
  mWidth: '@media screen and (min-width: 730px)',
  lWidth: '@media screen and (min-width: 820px)',
};

export const otherVariables = {
  trackHeight: '4px',
};
